import { useRouter } from 'next/router';

import CloseIcon from '@mui/icons-material/Close';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'next-i18next';
import config from 'src/config';
import { ROUTES } from 'src/helpers/constants';

import { DialogType } from '..';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

type Props = {
  dialog: DialogType;
};

const CitizenIdConnectOtherAccount = ({ dialog }: Props) => {
  const theme = useTheme();
  const router = useRouter();
  const { t } = useTranslation();

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <>
      <DialogTitle sx={{ px: '40px' }}>
        <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
          <IconButton onClick={dialog.close} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box display="flex" alignItems="center" flexDirection="column" rowGap="1">
          <FontAwesomeIcon
            style={{ fontSize: '50px' }}
            color={theme.palette.grey[500]}
            icon="fa-light fa-circle-exclamation"
          />
          <Typography color="primary.main" variant="h3" align="center" sx={{ mt: 2 }}>
            {t('citizen_id_cpd_connect_other_account.title')}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', px: 6.5 }}>
        <Typography variant="h7lanna" lineHeight="22px" component="div" sx={{ opacity: 0.87 }}>
          {t('citizen_id_cpd_connect_other_account.subtitle')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button
          sx={{ width: '120px' }}
          onClick={() => router.push(`${ROUTES.LOGOUT}?redirectUrl=${config.APP_DOMAIN}${ROUTES.LOGIN}`)}
          variant="contained"
          color="primary"
        >
          {t('confirm')}
        </Button>
      </DialogActions>
    </>
  );
};

export default CitizenIdConnectOtherAccount;
